"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailCustomersModule = void 0;
const inversify_1 = require("inversify");
const http_status_codes_1 = require("http-status-codes");
const RetailCustomer_1 = require("../../models/RetailCustomer");
const RetailSession_1 = require("../../models/RetailSession");
const errorTypes_1 = require("../../../../../apis/spg/helpers/errorTypes");
const constants_1 = require("./helpers/constants");
let RetailCustomersModule = class RetailCustomersModule {
    constructor(_httpConnection, _retailAuthModule) {
        this._httpConnection = _httpConnection;
        this._retailAuthModule = _retailAuthModule;
    }
    async signupRetailCustomer(retailCustomer, password, retailLocationId) {
        var _a, _b, _c;
        try {
            const response = await this._httpConnection.makeRequest({
                url: `retailCustomers`,
                method: "post",
                data: {
                    retailCustomer: retailCustomer.serialize(),
                    password,
                    retailLocationId
                },
                handleOwnError: true
            });
            if (!response.retailCustomer) {
                throw new errorTypes_1.ApiUnreachableError("Unable to speak to services API. The API may be down.");
            }
            return RetailCustomer_1.RetailCustomer.unserialize(response.retailCustomer);
        }
        catch (e) {
            if (!e.response) {
                throw e;
            }
            if (((_a = e.response) === null || _a === void 0 ? void 0 : _a.status) === http_status_codes_1.StatusCodes.BAD_REQUEST) {
                switch ((_c = (_b = e.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) {
                    case constants_1.TSignUpFormMessages.CustomerAlreadyExists:
                        throw new errorTypes_1.DuplicateEmailOnSignUpError(e);
                        break;
                    case constants_1.TSignUpFormMessages.CannotSendVerificationCode:
                        throw new errorTypes_1.VerificationCodeError(e);
                        break;
                    case constants_1.TSignUpFormMessages.EmailNotValid:
                        throw new errorTypes_1.InvalidEmailAddressError(e);
                        break;
                }
            }
            // if unable to handle rethrow
            throw e;
        }
    }
    async checkVerificationCode(otpCode, retailCustomerId) {
        try {
            const { session } = await this._httpConnection.makeRequest({
                url: `retailCustomers/verify-account/${retailCustomerId}`,
                method: "post",
                data: { verificationCode: otpCode },
                handleOwnError: true
            });
            const retailCustomerSession = RetailSession_1.RetailSession.unserialize(session);
            await this._retailAuthModule.setSession(retailCustomerSession);
            return retailCustomerSession;
        }
        catch (e) {
            const { response } = e;
            if (response.status === http_status_codes_1.StatusCodes.BAD_REQUEST) {
                switch (response.data.error) {
                    case constants_1.TSignUpFormMessages.InvalidAccountVerificationCode:
                        throw new errorTypes_1.InvalidVerificationCodeError(e);
                        break;
                    case constants_1.TSignUpFormMessages.AccountVerificationExpired:
                        throw new errorTypes_1.VerificationCodeExpired(e);
                        break;
                }
            }
            throw e;
        }
    }
    async resendVerificationCode(retailCustomerId) {
        await this._httpConnection.makeRequest({
            url: `retailCustomers/resend-verification-code/${retailCustomerId}`,
            method: "post"
        });
    }
    async retrieveRetailCustomer(id) {
        const { retailCustomer } = await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}`,
            method: "get"
        });
        return RetailCustomer_1.RetailCustomer.unserialize(retailCustomer);
    }
    async updateRetailCustomer(retailCustomer) {
        await this._httpConnection.makeRequest({
            url: `retailCustomers/${retailCustomer.id}`,
            method: "put",
            data: {
                retailCustomer: retailCustomer.serialize()
            }
        });
    }
    async checkEmailUniqueness(value) {
        const res = await this._httpConnection.makeRequest({
            url: "retailCustomers/check-email-uniqueness",
            method: "post",
            data: { value }
        });
        return res.isValid;
    }
    async checkPasswordStrength(value) {
        const res = await this._httpConnection.makeRequest({
            url: "retailCustomers/check-password-strength",
            method: "post",
            data: { value }
        });
        return res.isValid;
    }
    async updatePassword(id, newPassword) {
        await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/update-password`,
            method: "post",
            data: {
                newPassword
            }
        });
    }
    async sendPasswordResetToken(retailCustomerEmail) {
        await this._httpConnection.makeRequest({
            url: "retailCustomers/password-reset/send-token",
            method: "post",
            data: {
                email: retailCustomerEmail
            }
        });
    }
    async resetPassword(token, newPassword) {
        await this._httpConnection.makeRequest({
            url: "retailCustomers/password-reset/reset",
            method: "post",
            data: {
                token,
                newPassword
            }
        });
    }
    async registerMobilePushDevice(id, playerId, deviceName) {
        await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/register-mobile-push-device`,
            method: "post",
            data: { playerId, deviceName }
        });
    }
    async unregisterMobilePushDevice(id, playerId) {
        await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/unregister-mobile-push-device`,
            method: "post",
            data: { playerId }
        });
    }
    async retrievePaymentMethodByGatewayId(id, gatewayId) {
        const { creditCard } = await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/paymentMethods/${gatewayId}`,
            method: "get"
        });
        return creditCard;
    }
    async retrieveDefaultPaymentMethod(id) {
        const { creditCard } = await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/paymentMethods`,
            method: "get"
        });
        return creditCard;
    }
    async retrieveActivePaymentMethods(id) {
        const activeMethods = await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/activePaymentMethods`,
            method: "get"
        });
        return activeMethods;
    }
    async setupActivePaymentMethod(id) {
        const activeMethods = await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/activePaymentMethods/setup`,
            method: "get"
        });
        return activeMethods;
    }
    async removeActivePaymentMethod(id, paymentMethodId) {
        const activeMethods = await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/activePaymentMethods/remove/${paymentMethodId}`,
            method: "get"
        });
        return activeMethods;
    }
    async updatePaymentMethod(id, paymentToken) {
        const { creditCard } = await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/paymentMethods`,
            method: "post",
            data: {
                paymentToken
            }
        });
        return creditCard;
    }
    async preparePaymentMethod(id, paymentMethodId, storeAccountId) {
        const { creditCard } = await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/paymentMethods/prepare`,
            method: "post",
            data: {
                paymentMethodId,
                storeAccountId
            }
        });
        return creditCard;
    }
    async deletePaymentMethod(id) {
        await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}/paymentMethod`,
            method: "delete"
        });
    }
    async deleteRetailCustomer(id, password) {
        await this._httpConnection.makeRequest({
            url: `retailCustomers/${id}`,
            method: "delete",
            data: {
                password
            }
        });
    }
    async retrieveLocation() {
        const { location } = await this._httpConnection.makeRequest({
            url: `retailCustomers/location`,
            method: "get"
        });
        return location;
    }
    async setLocation(location) {
        await this._httpConnection.makeRequest({
            url: `retailCustomers/location`,
            method: "post",
            data: {
                location
            }
        });
    }
};
RetailCustomersModule = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)("HttpConnection")),
    __param(1, (0, inversify_1.inject)("AuthModule"))
], RetailCustomersModule);
exports.RetailCustomersModule = RetailCustomersModule;
//# sourceMappingURL=RetailCustomersModule.js.map